// Removes specific characters from string
export const sanitizeValue = (string) => {
    return string
        .replace(/</g, '') // <
        .replace(/script>/g, '') // script>
        .replace(/[\\/]/, ''); // / or \
};
